exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-2147c338]{width:100px;height:24px;line-height:24px;outline:none;border:none;border-bottom:1px solid #000;padding:0 6px;resize:none;overflow:hidden;vertical-align:middle}h1[data-v-2147c338]{font-size:30px;font-weight:700;text-align:center;margin-bottom:80px}.labor-tpl[data-v-2147c338]{width:100%;padding-top:100px;padding-bottom:60px;height:auto;font-size:16px;font-family:\\\\5B8B\\4F53}.labor-tpl p.l3[data-v-2147c338]{margin:32px;text-indent:0}.labor-tpl .default[data-v-2147c338]{width:50%!important}.labor-tpl p[data-v-2147c338]{text-indent:32px;line-height:2;margin:8px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2147c338","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/sys-contract/confidentiality.vue
// module id = a4ui
// module chunks = 57